export const EXPORT_TEMPLATE_DELETE = 'EXPORT_TEMPLATE_DELETE'
export const EXPORT_TEMPLATE_DELETE_SUCCESS = 'EXPORT_TEMPLATE_DELETE_SUCCESS'
export const EXPORT_TEMPLATE_DELETE_FAILED = 'EXPORT_TEMPLATE_DELETE_FAILED'

export const EXPORT_DATA = 'EXPORT_DATA'
export const EXPORT_DATA_SUCCESS = 'EXPORT_DATA_SUCCESS'
export const EXPORT_DATA_FAILED = 'EXPORT_DATA_FAILED'

export const SET_EXPORT_DATA_TEMPLATES_ORDER = 'SET_EXPORT_DATA_TEMPLATES_ORDER'
